export enum SpecialCampaignEnum {
  HenriqueEJuliano = "henrique-juliano",
  KamillaFialho = "kamilla-fialho",
  AnnoDomini = "anno-domini",
}
